// Import stylesheets
import './style.css';

import { midiFreqs, midiPitches, convertToSharp } from "./midiData.js"
import instrumentData from "./instrumentData.js"
import SnapURLSynchronizer from "./SnapURLSynchronizer"
var introJs = require('intro.js')
var $ = require('jquery')

require('webaudiofont'); // defines window.WebAudioFontPlayer, used below

var menuCollapsed = false;
console.log("in index");


// CONFIG
let SnapProjectName = "TuneScope.xml"
let defaultScreenName = "Snap" // Manually change order of adding modes if changing this


/* Load WebAudioFontPlayer and define functions*/

let playerConstructor = window.WebAudioFontPlayer
var player = new playerConstructor();
var AudioContextFunc = window.AudioContext || window.webkitAudioContext;
var audioContext = new AudioContextFunc();

let initialInstrumentName = "piano"
var currentInstrumentName = initialInstrumentName
let instrumentVolumes = {};

var currentInstrument = null;

/**
 * Used to determine the appropriate WebAudioFontPlayer instrument from a name
 * @param instrumentName
 * @since 2020.5.21
 * Written by Eric Stein, comment by Eric Stein
 */
function instrumentNameToValue(instrumentName) {
    return new Promise((resolve, reject) => {
        let selectedInstrumentData = instrumentData[instrumentName.toLowerCase()]
        if (selectedInstrumentData) {
            let path = selectedInstrumentData.path;
            let name = selectedInstrumentData.name;
            if (path && name) {
                player.loader.startLoad(audioContext, path, name);
                console.log("waiting for load")
                player.loader.waitLoad(function () {
                    console.log("finished loading")
                    resolve(window[name])
                });
            } else {
                console.error("Could not find instrument data for instrument with name " + instrumentName)
                reject();
            }
        } else {
            console.error("Could not find instrument data for instrument with name " + instrumentName)
            reject()
        }
    })
}

/** Used to change the current WebAudioFontPlayer instrument; returns a promise
 * Written by Eric Stein, comment by Eric Stein
 * @since 2020.1.26
 */
function changeInstrument(instrumentName) {
    return new Promise((resolve, reject) => {
        instrumentNameToValue(instrumentName).then((val) => {
            console.log("changing to ", val);
            currentInstrument = val;
            currentInstrumentName = instrumentName;
            resolve();
        }).catch((e) => {
            reject(e);
        })
    })
}

changeInstrument(initialInstrumentName).then(() => {
    console.log("changed instrument to initial instrument: ", initialInstrumentName);
    activateMicrophoneStreaming();
})

/** Used to play a note using WebAudioFontPlayer and the current instrument; returns a promise
 * Written by Eric Stein, comment by Eric Stein
 * @since 2020.1.26
 */
const playNote = (note, duration, instrumentName, volume) => {
    return new Promise((resolve, reject) => {
        // Get Appropriate Instrument
        var instrumentData = currentInstrument;
        new Promise((resolveInstrument, rejectInstrument) => {
            if (instrumentName) {
                instrumentNameToValue(instrumentName).then((val) => { // loads instrument
                    instrumentData = val;
                    resolveInstrument();
                })
            } else {
                instrumentName = currentInstrumentName
                resolveInstrument();
            }
        }).then(() => {
            instrumentName = instrumentName.toLowerCase();
            let durationDouble = parseFloat(duration)
            if (!Number.isNaN(durationDouble)) {

                // convert the given note to its sharped enharmonic
                // and extract the midi pitch and frequencies
                // in the event of a rest, we skip everything and resolve()
                note = convertToSharp(note);

                let rest = (note === "r" || note === "R");

                // only proceeds with playing a note if the midi note is not a rest
                if (!rest) {

                    //converts note to midi pitches and frequency
                    let midiPitch = midiPitches[note]
                    let midiFreq = midiFreqs[note]

                    if (midiPitch) {
                        // determine volume
                        let selectedVolume = null;
                        if (instrumentVolumes[instrumentName]) { // from set volume of instrument
                            console.log("found instrument volume")
                            selectedVolume = instrumentVolumes[instrumentName];
                        } else if (volume != null) {
                            let volumeInt = parseInt(volume);
                            if (volumeInt != null) {
                                selectedVolume = volumeInt / 100
                            }
                        }
                        // actually play sound
                        console.log(instrumentData);
                        player.queueWaveTable(audioContext, audioContext.destination, instrumentData, 0.1, midiPitch, durationDouble, selectedVolume); // actives microphone streaming
                        // display sound
                        let currentSoundID = currentSnapiFrame.addSound({ gain: selectedVolume, freq: midiFreq })

                        // remove sound when time is up
                        setTimeout(() => {
                            if (currentSnapiFrame) {
                                currentSnapiFrame.removeSound({ ID: currentSoundID })
                            }
                        }, durationDouble * 1000)
                        // resolve because we successfully played a note
                        resolve()
                    } else {
                        console.error("Could not find MIDI value for note " + note)
                        reject()
                    }
                } else {
                    // resolve because we rested
                    resolve()
                }
            } else {
                console.error("Provided duration could not be parsed into a double")
                reject()
            }
        })
    })
}

const stopPlayingNotes = () => {
    player.cancelQueue(audioContext);
}

/**
 * Activates audio output at startup by playing a silent (volume 0) note
 * Written by Eric Stein, comment by Eric Stein
 * @since 4/27/2020
 */
let activateMicrophoneStreaming = () => {
    playNote("C4", 1, null, 0).catch((err) => {
        console.log("error caught: ", err)
    })
}

let currentSnapiFrame = null // created or removed when the current source is changed (in selectMode)
const modeToSnapiFrame = {};

/** A class that is used to create/remove a Snap project in an iFrame that can communicate with SoundScope
 * Written by Eric Stein, comment by Eric Stein
 * @since 2020.1.14
 */
class snapiFrame {
    snapURLSynchronizer;

    expanded;
    currentSounds = {};
    currentSoundID = 0;

    visibleClassname = "Snap-Frame-Visible";
    expandedClassname = "Snap-Frame-Expanded";
    invisibleClassname = "Snap-Frame-Invisible";

    iFrameClassname = "Snap-iFrame";

    constructor(mode, parent) {

        window.currentSnapiFrame = this;

        this.snapURLSynchronizer = new SnapURLSynchronizer(this);

        this.expanded = false
        this.parent = parent;

        // create container
        this.container = document.createElement("div");

        // create iframe

        this.iframe = document.createElement("iframe");
        this.iframe.className = this.iFrameClassname
        // TODO: make snap frame start with editor
        // ./Snap/snap.html
        var src = "./Snap/snap.html#open:/" + SnapProjectName;
        this.mode = mode;
        this.iframe.setAttribute("src", src); // #open:TuneScope.xml

        // Call with initial URL
        this.snapURLSynchronizer.onTuneScopeURLChanged(window.location.href);

        // MORPHIC

        this.iframe.onload = () => {

            try {
                this.snapWorld = this.iframe.contentWindow.world
                this.snapIde = this.snapWorld.children[0];

                console.log(this.snapIde)
                this.onInitialSnapLoad();
            } catch (err) {
                console.log("Error after loading Snap! iFrame: ", err);
            }

        }

        // Combine everything

        this.container.append(this.iframe)

        this.parent.append(this.container)

        this.expand() // remove to make snapiFrame start as not expanded
        this.show()
    }

    onInitialSnapLoad = () => {
        // Listen for project loads
        this.snapIde.listenForLocalUserProjectOpen(this.onSnapProjectLoaded)
        this.snapIde.listenForNewProject(this.onNewProject);
        this.snapIde.listenForStopButtonClicked(this.onStopButtonClicked)
        this.setFlatTheme()
    }

    onStopButtonClicked = () => {
        // stop playing all currently playing notes
        stopPlayingNotes()
    }

    onSnapProjectLoaded = (projectName, username) => {
        this.snapURLSynchronizer.onSnapProjectLoaded(projectName, username);
    }

    onNewProject = () => {
        this.snapURLSynchronizer.onNewProject()
    }

    /**
     * loads a snap project given a Snap! project url
     * @param url
     */
    loadSnapProject = (url) => {
        return new Promise((resolve, reject) => {

            setTimeout(function () {
                currentSnapiFrame.expand();
            }, 100);
            if (url.includes("snap.html")) {
                this.snapURLSynchronizer.parseTuneScopeURL(url).then((response) => {
                    const { username, projectName } = response;
                    setTimeout( () => {
                        this.snapIde.loadPublicProject(username, projectName).then(resolve).catch(reject);
                    }, 3000);
                }).catch((err) => {
                    reject("Failed to parse Snap! project: " + err)
                })
            } else {
                reject("Invalid URL")
            }
        })
    }

    hide = () => {
        this.container.className = this.invisibleClassname
    }

    show = () => {
        if (this.expanded) {
            if (menuCollapsed) {
                this.container.className = "Snap-Frame-Expanded-Menu-Collap";
            } else {
                this.container.className = this.expandedClassname;
            }
        } else {
            this.container.className = this.visibleClassname
        }
    }

    updateGraph = () => {
        drawData()
    }

    addSound = (config) => {
        let { gain, freq } = config
        let soundData = {
            gain: gain,
            freq: freq
        }
        let ID = this.currentSoundID;
        this.currentSoundID++
        this.currentSounds[ID] = soundData
        this.updateGraph()
        return ID;
    }

    removeSoundID = (ID) => {
        this.currentSounds[ID] = null
        this.updateGraph()
    }

    removeSound = (config) => {
        if (config.ID !== null && config.ID !== undefined) {
            this.removeSoundID(config.ID)
        }
    }

    getSounds = () => {

        return Object.values(this.currentSounds)
    }

    expand = () => {
        this.expanded = true;
        if (menuCollapsed) {
            this.container.className = "Snap-Frame-Expanded-Menu-Collap";
        } else {
            this.container.className = this.expandedClassname;
        }
        freezeDisplay();
    }

    shrink = () => {
        this.expanded = false;
        this.container.className = this.visibleClassname
        thawDisplay();
    }

    setFlatTheme = () => {
        this.snapIde.setSnapFlat();
    }
    setDarkTheme = () => {
        this.snapIde.setSnapDark();
    }
}

class ResizeSnapButton {
    button;
    expandedText;
    minimizedText;
    defaultText;

    constructor() {
        this.expandedText = "Scope";
        this.minimizedText = "Scope";
        this.defaultText = this.expandedText;

        this.button = this.build()
        document.getElementById("selectDiv").appendChild(this.button)
    }

    build = () => {
        let resizeSnapButton = document.createElement('button');
        resizeSnapButton.classList.add("toggle-btn", "freeze-btn", "resize-snap-btn", "collapItm");
        resizeSnapButton.setAttribute("name", "resize-snap-button")
        resizeSnapButton.appendChild(document.createElement('span'));
        resizeSnapButton.innerHTML = this.defaultText;
        resizeSnapButton.addEventListener("click", (event) => {
            event.preventDefault();
            if (currentSnapiFrame) {
                if (currentSnapiFrame.expanded) {
                    resizeSnapButton.innerHTML = this.minimizedText;
                    currentSnapiFrame.shrink();
                } else {
                    resizeSnapButton.innerHTML = this.expandedText;
                    currentSnapiFrame.expand();
                }
            }
        }, false);
        return resizeSnapButton;
    }

    show = () => {
        this.button.style.visibility = "visible";
        this.button.classList.remove("resize-snap-btn-invisible");
    }

    hide = () => {
        this.button.style.visibility = "hidden";
        this.button.classList.add("resize-snap-btn-invisible");
    }
}

let currentResizeSnapButton = new ResizeSnapButton();
currentResizeSnapButton.hide();

var mediaRecorder = null;
var audio = null;
var introJsOsc = introJs();
introJsOsc.setOption("showBullets", true);
introJsOsc.setOption("exitOnOverlayClick", false);
var tutorialMode = false;
// end recordAudio const

var AudioContext = (window.AudioContext || window.webkitAudioContext || window.mozAudioContext || window.oAudioContext || window.msAudioContext);

var streaming = false;
var newId = 0;
// define tooltips for each data point
var dots = [];
audioContext = new AudioContext();
var gainNode = audioContext.createGain();
var analyser = audioContext.createAnalyser();
gainNode.gain.value = 3;
analyser.smoothingTimeConstant = .9;
try {
    analyser.fftSize = 1024 * 16; // potentially should be less to have higher canvas response
} catch (e) {
    analyser.fftSize = 2048;
}
gainNode.connect(analyser);
// frequencyBinCount is readonly and set to fftSize/2;
var timeDomain = new Uint8Array(analyser.frequencyBinCount);
streaming = false;
var sampleRate = audioContext.sampleRate;
var numSamples = analyser.frequencyBinCount;

const audioInputSelect = document.querySelector('select#audioSource');
const audioInputSourceSelect = document.querySelector('select#audioInput');
const selectors = [audioInputSelect, audioInputSourceSelect];

navigator.mediaDevices.enumerateDevices().then((deviceInfos) => {
    gotDevices(deviceInfos)
}).catch(handleError);

var mode = document.getElementById("audioSource");
mode.addEventListener('change', (function (event) {
    event.preventDefault();
    var modeId = mode.selectedIndex;
    var whichMode = mode.options[modeId].value;
    selectMode(whichMode);
    enableMic()
}), false);
setTimeout(() => {
    defaultScreenName !== "" && selectMode(defaultScreenName);
}, 100)

var currFreq = 1000

createAnOscillator();

var ui = {
    freeze: { // freeze live input
        value: false,
    },
    gain: { // amplitude
        value: 1,
    },
    dropdownExample: { // time domain (ms / div)
        value: 10,
    },
    volts: { // volts / div
        value: 1,
    },
    vertOffset: { // vertical offset
        value: 0,
    }
};

/*------------------------------------------------------------------------------------
                                CREATE CANVASES
/*----------------------------------------------------------------------------------*/
var demo = document.getElementById('demo'); // PREVENT SCROLLING
var c = document.createElement("canvas"); // for gridlines
c.id = "gridLines";

var c2 = document.createElement("canvas"); // for animated line
c2.id = "animatedLines";

var tipCanvas = document.createElement("canvas"); // for tooltips
tipCanvas.id = "tip";

c.width = demo.clientWidth;
c.height = document.getElementById('demo').clientHeight;

c2.width = demo.clientWidth;
c2.height = c.height;
c.style.backgroundColor = "#fefefe";

demo.appendChild(c);
demo.appendChild(c2);
demo.appendChild(tipCanvas);

var midPoint = { x: 0, y: c.height / 2 };

var ctx = c.getContext("2d");
ctx.textAlign = 'center';
ctx.textBaseline = "alphabetic";
ctx.font = "1.2em Franklin Gothic Medium";
ctx.fillStyle = "#000";
var ctx2 = c2.getContext("2d");
var tipCtx = tipCanvas.getContext("2d");
tipCtx.font = "1.2em Franklin Gothic Medium";
tipCtx.fillStyle = '#E57200';

window.addEventListener("resize", refreshCanvas);

var mapRange = function (from, to, s) {
    return to[0] + (s - from[0]) * (to[1] - to[0]) / (from[1] - from[0]);
};

var mapRangeInv = function (from, to, s) {
    return from[0] + (s - to[1]) * (from[1] - from[0]) / (to[1] - to[0]);
}

var previousTranslate = { x: 0, y: 0 };

createGrid(ctx);


var canvasOffset = $("#demo").offset();
var offsetX = canvasOffset.left;
var offsetY = canvasOffset.top;

$("#demo").mousemove(handleMouseMove);

createUiVertOffset();
giveTutorial();
addIntroData();

document.getElementById('addanother').addEventListener("click", (function (event) {
    event.preventDefault();
    createAnOscillator();

    if (tutorialMode === true) {
        introJsOsc.addSteps([
            {
                element: document.getElementsByClassName("toggle1")[0],
                intro: "Click ON to turn the second oscillator on.",
                position: 'right'
            },
            {
                element: document.getElementsByClassName("mute1")[0],
                intro: "<img src='https://cdn-prod.medicalnewstoday.com/content/images/articles/322/322868/golden-retriever-puppy.jpg' width='200px'/><b>If you like, you can also click the MUTE button to mute the sound.</b>",
                position: 'right'
            },
            {
                element: document.getElementsByClassName("fs1")[0],
                intro: "Set the second oscillator to 400 Hz.",
                position: 'bottom-left'
            },
            {
                element: document.getElementById('demo'),
                intro: "<h3>Combined Wave</h3>A single cycle of the combined waveform looks like this. A complete cycle still takes the same amount of time (one-hundredth of a second). However, the waveform is no longer a pure tone. Combining the 200 Hz tone with a 400 Hz tone results in a complex waveform. A complex waveform consists of two or more frequencies mixed together. Addition of the 400 Hz tone results in a double peak in a single cycle – one large peak and a second smaller one."
            },
            {
                element: document.getElementById('demo'),
                intro: "<h3>See more Details</h3>Hover your mouse over the waveform to view its coordinates. The coordinates at the mouse cursor are displayed in (milliseconds, amplitude)."
            },
            {
                element: document.getElementById("saveBtn"),
                intro: "<h3>Export</h3>Click EXPORT to save the waveform into clipboard. Waveform is exported as a set of coordinates for further studies. Isn't SoundScope fun? click Done to exit tutorial!",
                position: 'right'
            }
        ]);

        introJsOsc.goToStepNumber(12).start();
    }



}), false);


/*------------------------------------------------------------------------------------
                                UTILITY FUNCTIONS
/*----------------------------------------------------------------------------------*/
function addIntroData() {
    /**
     * Data basic intro data for the Tutorial
     */


    introJsOsc.addSteps([
        {
            element: document.getElementById("tutorialBtn"),
            intro: "<h3>Introduction</h3>This is a demonstration of the way in which basic acoustic concepts can be introduced through SoundScope. These concepts provide the foundation for music synthesis.",
            position: 'bottom-middle-aligned'
        },
        {
            element: document.getElementById('soundscopelogo'),
            intro: "SoundScope is a tool that can be used to explore these concepts interactively.",
            position: 'bottom-middle-aligned'
        },
        {
            element: document.getElementsByClassName('toggle0')[0],
            intro: "<h3>Let's begin</h3>Begin by clicking the ON button to turn on an oscillator. This will generate a low-pitched tone.",
            position: 'right'
        },
        {
            element: document.getElementsByClassName("mute0")[0],
            intro: "<h3>Mute Button</h3>If you like, you can also click the MUTE button to mute the sound.",
            position: 'right'
        },
        {
            element: document.getElementsByClassName("freqboxwrapper0")[0],
            intro: "<h3>Sine Wave</h3>The graph of a pure tone that consists of only a single frequency produces a sine wave. In the case of a 100 Hz tone, one cycle of the waveform is completed in 10 milliseconds. Since there are 1000 milliseconds in a second, 100 cycles of the tone will be completed in one second.",
            position: 'top'
        },
        {
            intro: "<h3>A Single Wave</h3>hA single cycle of the sine wave represents one back-and-forth movement. When the tone is sent to a speaker, the positive peak will move the speaker cone in one direction and the negative peak will move the cone in the opposite direction.",
        },
        {
            element: document.getElementById('demo'),
            intro: "<h3>Number of Cycles</h3>The number of cycles can be calculated by counting the peaks. In this instance, there are ten positive peaks in one-tenth of a second. This means that there were ten complete cycles of the waveform in that time period. Since this is a 100 Hz tone, the result obtained in this way matches our expectations.",
            position: 'bottom-middle'
        },
        {
            element: document.getElementsByClassName("fs0")[0],
            intro: "<h3>Frequency</h3>Change the frequency of the tone from 100 to 200 Hz. Every tone has a frequency and an amplitude. The pitch of the tone that you hear should increase.",
            position: 'bottom-middle'
        },
        {
            element: document.getElementsByClassName("vs0")[0],
            intro: "<h3>Amplitude</h3>Change the amplitude of the tone from 0.5 V to 0.25 V. The loudness of the tone that you hear should decrease.",
            position: 'bottom-middle'
        },
        {
            element: document.getElementsByClassName("sliderWrapper")[0],
            intro: "<h3>Physical Atrributes of Sound</h3>Amplitude and frequency are the physical attributes of sound. Pitch is the perceptual correlate of frequency. Loudness is the perceptual correlate of frequency. Pitch and loudness are the way in which these attributes are perceived by the auditory system.",
            position: 'top'
        },
        {
            element: document.getElementById("addanother"),
            intro: "<h3>Combining Waves</h3>Click ADD to add a second oscillator. What do the two tones sound like when they are combined?",
            position: 'top-left'
        }

    ]);


}

function createUiVertOffset() {
    /**
     * Create a vertical offset inside canvas
     */

    let vertOffset = document.createElement('input');
    vertOffset.id = "vertOffset";

    vertOffset.classList.add("tone-slider", "vOffset");


    vertOffset.setAttribute('type', 'range');
    vertOffset.setAttribute('orient', 'vertical');


    vertOffset.setAttribute('min', 0);
    vertOffset.setAttribute('max', 200);
    vertOffset.setAttribute('value', 100);
    vertOffset.addEventListener("input", (function (event) {
        event.preventDefault();
        // implement v-offset slider here
        ui.vertOffset.value = -(parseInt(vertOffset.value) - 100);
        update();
    }), false);

    let selectDiv = document.getElementById('demo');
    selectDiv.appendChild(vertOffset);
}

function giveTutorial() {
    /**
     * Gives a tutorial to Soundscope.
     *
     * Provides a step-by-step tutorial on how to use Soundscope for instructional purposes of learning soundwave and synthesis.
     *
     * @since 2019.08.31
     *
     * @listen event:click
     *
     * @param {} none.
     * @return {} none.
     */
    // Create a tutorial button
    let tutorialBtn = document.createElement('button')
    tutorialBtn.id = "tutorialBtn";
    tutorialBtn.classList.add("toggle-btn");
    tutorialBtn.innerHTML = "SHOW ME";


    tutorialBtn.addEventListener('click', () => {
        startTutorial();
    })
    // Add into preamble div
    let preambleDiv = document.getElementById('selectDiv');
    preambleDiv.appendChild(tutorialBtn);
}

function startTutorial() {
    tutorialMode = true;
    introJsOsc.onexit(function () {
        tutorialMode = false;
    });
    introJsOsc.start();
}


function refreshCanvas() {
    /** To adjust canvas to browser resize.
     * @return {void} none
     */

    let c = document.getElementById("gridLines");
    c.width = demo.clientWidth;
    var ctx = c.getContext("2d");
    ctx.canvas.width = demo.clientWidth;
    ctx.textAlign = 'center';
    ctx.textBaseline = "alphabetic";
    ctx.font = "1.2em Franklin Gothic Medium";
    ctx.fillStyle = "#000";


    let c2 = document.getElementById("animatedLines");
    c2.width = demo.clientWidth;
    var ctx2 = c2.getContext("2d");
    ctx2.canvas.width = demo.clientWidth;

    let tip = document.getElementById("tip");
    tip.width = demo.clientWidth;
    var tipCtx = tip.getContext("2d");
    tipCtx.canvas.width = demo.clientWidth;
    tipCtx.font = "1.2em Franklin Gothic Medium";
    tipCtx.fillStyle = '#E57200';


    createGrid(ctx);
    update();
}

// Create freqMode switch (max 1000 hz vs 10000 hz)


function update() {
    /** Redraws the wave curve on the canvas with drawData()
     * Skipped while the live input is streaming and not frozen, since animate() is already redrawing it
     * Written by Rich Nguyen, comment by Alex Li
     * @return {void} none
     */
    if (!(streaming === true && ui.freeze.value === false)) {
        drawData();
    }
}

function enableMic() {
    streaming = true;
    if (window.stream) {
        window.stream.getTracks().forEach(track => {
            track.stop();
        });
    }
    let micPanel = document.getElementById("micPanel");
    if (!micPanel) {
        addMicPanel();
    }

    // MIC INPUT USED HERE
    const audioSource = audioInputSourceSelect.value;
    const constraints = {
        audio: { deviceId: audioSource ? { exact: audioSource } : undefined }
    };
    navigator.mediaDevices.getUserMedia(constraints).then(gotStream).then(gotDevices).catch(handleError);
    ui.gain.value = 1;
    ui.freeze.value = false;
}

function selectMode(whichMode) {
    /** Changes between oscillator mode, or recording mode
     * Called when dropdown menu change event is called
     * @param {element} selectObj html element of a dropdown menu allowing selection of modes
     * @return {void} none
     */

    if (whichMode === "Oscillators") {
        streaming = false;
        removeMicPanel();

        selectAudioInputSource("Oscillators");

        enableDemo();
        showAllOscillators();
        showAddBtn();
        currentSnapiFrame && currentSnapiFrame.hide()
        currentSnapiFrame = null;
        document.getElementById("oscillators-container").style.visibility = "visible"
        currentResizeSnapButton && currentResizeSnapButton.hide();

    } else if (whichMode === "Snap") {
        enableMic() // TODO; enable toggle
        removeMicPanel();
        hideAllOscillators();
        document.getElementById("oscillators-container").style.visibility = "hidden"
        hideAddBtn();
        disableDemo();

        // set correct Snap! iFrame as current, create one if it does not yet exist, and hide current Snap iFrame (if any)
        let onCorrectMode = false;
        if (currentSnapiFrame) {
            if (!(currentSnapiFrame.mode === "snap")) {
                currentSnapiFrame.hide();
            } else {
                onCorrectMode = true;
            }
        }
        if (!onCorrectMode) {
            if (!modeToSnapiFrame["snap"]) {
                modeToSnapiFrame["snap"] = new snapiFrame('snap', document.getElementById("mainBody"))
            }
            currentSnapiFrame = modeToSnapiFrame["snap"];
        }

        currentSnapiFrame.show()
        currentResizeSnapButton && currentResizeSnapButton.show();
    } else {
        enableMic()
        hideAllOscillators();
        document.getElementById("oscillators-container").style.visibility = "visible" // for recording
        hideAddBtn();
        disableDemo();
        currentSnapiFrame && currentSnapiFrame.hide()
        currentResizeSnapButton && currentResizeSnapButton.hide();

    }
    update();
};


const freezeDisplay = () => {
    ui.freeze.value = true;
    Array.from(document.getElementsByName("freeze-button")).forEach((el) => {
        el.innerHTML = "UNFREEZE";
    })
    update();
}

const thawDisplay = () => {
    ui.freeze.value = false;
    Array.from(document.getElementsByName("freeze-button")).forEach((el) => {
        el.innerHTML = "FREEZE";
    })
    animate();
}

/**
 * Creates and returns a freeze button.
 * Written by Rich Nguyen, Comment by Eric Stein
 * @since 4/29/2020
 * @returns {HTMLButtonElement}
 */
let createFreezeButton = () => {
    let freezeBtn = document.createElement('button');
    freezeBtn.classList.add("toggle-btn", "freeze-btn", "collapItm");
    freezeBtn.setAttribute("name", "freeze-button")
    freezeBtn.appendChild(document.createElement('span'));
    freezeBtn.innerHTML = "FREEZE";
    freezeBtn.addEventListener("click", (function (event) {
        event.preventDefault();
        if (!ui.freeze.value) {
            freezeDisplay();
        } else {
            thawDisplay();
        }
    }), false);
    return freezeBtn;
}

let topFreezeBtn = createFreezeButton()
document.getElementById("selectDiv").appendChild(topFreezeBtn)

function addMicPanel() {
    /** Create div object with a play, mute, and freeze button to control recording input modes
     * @since 2019.12.17
     * @return {void} none
     */
    let parent = document.getElementById("oscillators");
    let micPanel = document.createElement("div");
    micPanel.id = "micPanel";
    micPanel.classList.add("mic");

    let label = document.createElement('label');
    label.innerHTML = "MIC CONTROL:";

    // Create a Play button
    let playBtn = document.createElement('button');
    playBtn.classList.add("toggle-btn", "play-btn");
    playBtn.setAttribute('data-playing', 'false');
    playBtn.appendChild(document.createElement('span'));
    playBtn.disabled = true;
    playBtn.innerHTML = "PLAY";
    playBtn.addEventListener("click", (function (event) {
        event.preventDefault();

        if (playBtn.getAttribute('data-playing') === 'false') {
            (async () => {
                audio.play();
                playBtn.classList.add("Playing");
                audio.addEventListener("ended", function () {
                    playBtn.classList.remove("pause-btn", "Playing");
                    playBtn.innerHTML = "PLAY";
                    playBtn.setAttribute('data-playing', 'false');
                });
            })();
            playBtn.classList.add("pause-btn");
            playBtn.innerHTML = "PAUSE";
            playBtn.setAttribute('data-playing', 'true');
            ui.freeze.value = false;
        }
        else {
            (async () => {
                audio.pause();
            })();
            playBtn.classList.remove("pause-btn", "Playing");
            playBtn.innerHTML = "PLAY";
            playBtn.setAttribute('data-playing', 'false');
            ui.freeze.value = true;
        }

        update();
    }), false);

    // Create a Record button
    let recordBtn = document.createElement('button');
    recordBtn.classList.add("toggle-btn", "record-btn", "notRec");
    recordBtn.setAttribute('data-recording', 'false');
    recordBtn.appendChild(document.createElement('span'));
    recordBtn.innerHTML = "REC";
    recordBtn.addEventListener("click", (function (event) {
        event.preventDefault();

        if (recordBtn.getAttribute('data-recording') === 'false') {
            recordBtn.setAttribute('data-recording', 'true');
            recordBtn.innerHTML = "STOP";
            recordBtn.classList.remove("notRec");
            recordBtn.classList.add("Rec");
            navigator.mediaDevices.getUserMedia({ audio: true })
                .then(stream => {
                    mediaRecorder = new MediaRecorder(stream);
                    mediaRecorder.start();

                    const audioChunks = [];
                    mediaRecorder.addEventListener("dataavailable", event => {
                        audioChunks.push(event.data);
                    });

                    mediaRecorder.addEventListener("stop", () => {
                        const audioBlob = new Blob(audioChunks);
                        const audioUrl = URL.createObjectURL(audioBlob);
                        console.log(audioUrl)
                        audio = new Audio(audioUrl);

                    });
                });

        } else {

            audio = mediaRecorder.stop();
            playBtn.disabled = false;

            recordBtn.classList.remove("Rec");
            recordBtn.classList.add("notRec");
            recordBtn.innerHTML = "REC";
            recordBtn.setAttribute('data-recording', 'false');
        };

    }), false);

    let freezeBtn = createFreezeButton()


    // Add the created buttons into the panel
    micPanel.appendChild(label);

    micPanel.appendChild(recordBtn);
    micPanel.appendChild(playBtn);
    micPanel.appendChild(freezeBtn);



    parent.insertBefore(micPanel, parent.childNodes[0]);
}

function disableDemo() {
    /** Disables the Demo button because there's no demo on the mic selection
     * Adds demo button to "freeze-btn" css class to change the button to grey
     * @return {void} none
     */
    let tutorialBtn = document.getElementById("tutorialBtn")
    tutorialBtn.classList.add("freeze-btn");
    tutorialBtn.style.display = "none";
    tutorialBtn.disabled = true;
}

function enableDemo() {
    /** Enables the Demo button
     * Removes demo button from "freeze-btn" css class to change the button back to original color
     * @since 2019.12.18
     * @return {void} none
     */
    let tutorialBtn = document.getElementById("tutorialBtn")
    tutorialBtn.classList.remove("freeze-btn");
    tutorialBtn.style.display = "initial";
    tutorialBtn.disabled = false;

}



function removeMicPanel() {
    /** Removes mic panel in the document
     * Iterates through children of mic panel and removes them
     * @since 2019.12.19
     * @return {void} none
     */
    let micPanel = document.getElementById("micPanel");
    if (micPanel) {
        let parent = micPanel.parentElement;

        while (micPanel.childNodes.length > 0) {
            micPanel.removeChild(micPanel.childNodes[0]);
        }

        parent.removeChild(micPanel);
    }
}

function gotStream(stream) {
    // Create an AudioNode from the stream.
    window.mediaStreamSource = audioContext.createMediaStreamSource(stream);
    window.stream = stream;

    window.mediaStreamSource.connect(gainNode);

    streaming = true;
    animate();
    // Refresh button list in case labels have become available
    return navigator.mediaDevices.enumerateDevices();

}



function hideAddBtn() {
    /** Sets visibility of addBtn to hidden
     * addBtn is html element with id = "addanother"
     * Used when switching modes, called by selectMode(selectObj)
     * Written by Rich Nguyen, comment by Alex Li
     * @since 2019.12.19
     * @return {void} none
     */
    let addBtn = document.getElementById("addanother");
    addBtn.style.visibility = "hidden";
}

function showAddBtn() {
    /** Sets visibility of addBtn to visible
     * addBtn is html element with id = "addanother"
     * Used when switching modes, called by selectMode(selectObj)
     * Written by Rich Nguyen, comment by Alex Li
     * @since 2019.12.19
     * @return {void} none
     */
    let addBtn = document.getElementById("addanother");
    addBtn.style.visibility = "visible";
}


function gotDevices(deviceInfos) {
    // Handles being called several times to update labels. Preserve values.
    const values = selectors.map(select => select.value);
    selectors.forEach(select => {
        while (select.firstChild) {
            select.removeChild(select.firstChild);
        }
    });

    // Create Snap source
    var snapOption = document.createElement('option');
    snapOption.value = "Snap";
    snapOption.text = "Snap!";
    audioInputSelect.appendChild(snapOption);

    // Create oscillators source
    var option = document.createElement('option');
    option.value = "Oscillators";
    option.text = "Oscillators (On-board)"
    audioInputSelect.appendChild(option);

    // Create basic Audio Input mode
    var audioInputOption = document.createElement('option');
    audioInputOption.value = "Audio Input";
    audioInputOption.text = "Audio Input"
    audioInputSelect.appendChild(audioInputOption);

    for (let i = 0; i !== deviceInfos.length; ++i) {
        const deviceInfo = deviceInfos[i];
        const option = document.createElement('option');
        option.value = deviceInfo.deviceId;
        if (deviceInfo.kind === 'audioinput') {
            option.text = deviceInfo.label || `microphone ${audioInputSelect.length + 1}`;
            var defaultText = option.text;
            if (defaultText.startsWith("Default") === false) {
                audioInputSourceSelect.appendChild(option);
            }
        }
    }
    // Add None Option
    const noneAudioInputOption = document.createElement('option');
    noneAudioInputOption.value = "Oscillators";
    noneAudioInputOption.text = "Oscillators" // change back if necessary
    audioInputSourceSelect.appendChild(noneAudioInputOption);


    selectors.forEach((select, selectorIndex) => {
        if (Array.prototype.slice.call(select.childNodes).some(n => n.value === values[selectorIndex])) {
            select.value = values[selectorIndex];
        }
    });
}

let selectAudioInputSource = (whichMode) => {
    const mode = audioInputSourceSelect;//document.getElementById("audioSource");
    const currMode = mode.options[mode.selectedIndex].value;
    if (whichMode !== currMode) {
        clearScope();
        // update mode synthetically
        for (var i = 0; i < mode.options.length; i++) {
            const currOption = mode.options[i];
            if (currOption.value === whichMode) {
                mode.selectedIndex = i;
                break;
            }
        }

        if (whichMode !== "Oscillators") {
            enableMic()
        }
    }
}

const onAudioInputSourceSelectChanged = (event) => {
    var mode = audioInputSourceSelect;//document.getElementById("audioSource");
    var modeId = mode.selectedIndex;
    var whichMode = mode.options[modeId].value;
    selectAudioInputSource(whichMode);
}
audioInputSourceSelect.addEventListener("change", onAudioInputSourceSelectChanged, false)

function handleMouseMove(e) {
    /** If cursor is on animated line, draw on tipCanvas the x,y coordinates of the cursor at the mouse position
     *
     * Written by Rich Nguyen, comment by Alex Li
     * @since 2019.12.19
     * @param {event} e eventObject that contains information about position of mouse
     * @return {void} none
     *
     */
    let mouseX = parseInt(e.clientX - offsetX);
    let mouseY = parseInt(e.clientY - offsetY);

    if (ctx2.isPointInPath(mouseX, mouseY)) {
        tipCtx.clearRect(0, 0, tipCanvas.width, tipCanvas.height);
        // How to extract the dots
        var mode = document.getElementById("audioSource");
        var modeId = mode.selectedIndex;
        var whichMode = mode.options[modeId].value;
        var i = 0;
        if (whichMode === "Oscillators") {
            i = parseInt(mouseX * analyser.frequencyBinCount / c.width);
        }
        else { // Mic/Amp Mode
            var mouseXremap = mapRangeInv([0, 0.001 * ui.dropdownExample.value], [0, 100 * (numSamples / sampleRate) / c.width], mouseX);
            i = parseInt(mouseXremap * analyser.frequencyBinCount / c.width);
        }
        var dot = dots[i];
        // Draw the dots
        tipCanvas.style.left = (dot.x) + "px";
        tipCanvas.style.top = (dot.y - 20) + "px";
        tipCanvas.style.background = ''
        tipCtx.beginPath();
        tipCtx.rect(3, 20, 6, 6);
        tipCtx.fill();
        let tip = "(" + x2time(dot.x) + ", " + y2amplitude(dot.yTip) + ")";
        tipCtx.fillText(tip, 5, 15);
    }
    else {
        tipCtx.clearRect(0, 0, tipCanvas.width, tipCanvas.height);
    }
}

function hideAllOscillators() {
    /** Sets visibility of all oscillators to hidden
     * Written by Rich Nguyen, comment by Alex Li
     * @since 2019.12.19
     * @return {void} none
     */
    var oscs = document.getElementsByClassName('oscillator');
    for (let i = 0; i < oscs.length; i++) {
        oscs[i].style.visibility = "hidden";
    }
}

function changeMaxFreqOnAllOscillators(newFreq) {
    /** Sets the maximum frequency of all the oscillators to a new frequency
     * Called by onFreqModeChange()
     * Not functional, wave graph is static, so cannot adjust to showing larger frequency ranges clearly
     * Written by Eric Stein, comment by Alex Li
     * @since 2019.12.20
     * @param {int} newFreq New maximum frequency to set the oscillators to
     * @return {void} none
     *
     */

    var oscs = document.getElementsByClassName('oscillator');
    for (let i = 0; i < oscs.length; i++) {
        let player = oscs[i].player
        let freqSlider = player.freqSlider
        freqSlider.setAttribute('max', newFreq);
        if (oscs[i].player.oscillator.frequency.value > newFreq) {
            setFreq(newFreq, oscs[i].player, oscs[i].player.freqSlider, oscs[i].player.freqBox)
        }
    }
}


let freqDropdown = document.getElementById("freqModeSelect")
function onFreqModeChange() {
    /** Onclick function of check box type element that changes max frequency of oscillators to either 10000 or 1000
     * Written by Eric Stein, comment by Alex Li
     * @since 2019.12.20
     * @return {void} none
     */

    currFreq = freqDropdown.value
    changeMaxFreqOnAllOscillators(currFreq)
}
document.getElementById("freqMode").addEventListener("click", onFreqModeChange, false);
document.getElementById("freqMode").addEventListener("mouseleave", onFreqModeChange, false);
// minor bug: not always called until mouse move is detected on mac google chrome

function showAllOscillators() {
    /** Sets visibility of all oscillators to visible
     * Called by selectMode(selectObj) function to switch to Oscillator mode
     * Written by Rich Nguyen, comment by Alex Li
     * @since 2019.12.20
     * @return {void} none
     */
    var oscs = document.getElementsByClassName('oscillator');
    for (let i = 0; i < oscs.length; i++) {
        oscs[i].style.visibility = "visible";
    }
}



function createAnOscillator() {
    /** Creates one oscillator and adds it to the oscilaltor div
     * Called by the addanother button
     * Written by Rich Nguyen, comment by Alex Li
     * @since 2019.12.20
     * @return {void} none
     */
    var oscParentEl = document.getElementById('oscillators'),
        oscElTxt = document.createElement('label'),
        oscEl = document.createElement('div'),
        onoffBtn = document.createElement('button'),
        removeBtn = document.createElement('button'),
        muteBtn = document.createElement('button'),
        sliderWrapper = document.createElement('div'),
        volumeTxt = document.createElement('label'),
        volumeBox = document.createElement('input'),
        volumeBoxWrapper = document.createElement('div'),
        volumeSlider = document.createElement('input'),
        dividerDiv = document.createElement('div'),
        freqSlider = document.createElement('input'),
        freqTxt = document.createElement('label'),
        freqBox = document.createElement('input'),
        on = document.createElement('span'),
        off = document.createElement('span'),
        thisPlayer = {},
        freqboxwrapper = document.createElement('div');

    thisPlayer.context = new AudioContext();
    thisPlayer.oscillator = thisPlayer.context.createOscillator();
    thisPlayer.gainobj = thisPlayer.context.createGain();
    thisPlayer.oscillator.frequency.value = 100;
    thisPlayer.gainobj.gain.value = 1;
    thisPlayer.oscillator.connect(thisPlayer.gainobj);
    thisPlayer.gainobj.connect(thisPlayer.context.destination);
    thisPlayer.playing = false;
    thisPlayer.first = true;
    thisPlayer.freqSlider = freqSlider
    thisPlayer.freqBox = freqBox
    thisPlayer.volumeSlider = volumeSlider;
    thisPlayer.volumeBox = volumeBox;
    thisPlayer.onoffBtn = onoffBtn;

    oscEl.player = thisPlayer

    oscEl.classList.add("oscillator", "osc" + newId);

    oscEl.setAttribute("data-id", newId);
    oscElTxt.classList.add("oscillatorText")
    oscElTxt.innerHTML = "Tone " + (newId + 1) + ":";

    oscEl.appendChild(oscElTxt);

    onoffBtn.classList.add("toggle-btn", "toggle" + newId);

    on.setAttribute('class', 'on');
    on.innerHTML = "ON"

    onoffBtn.appendChild(on);
    off.setAttribute('class', 'off');
    off.innerHTML = "OFF"
    onoffBtn.appendChild(off);
    onoffBtn.addEventListener("click", (function (event) {
        event.preventDefault();
        this.classList.toggle('switch');
        toggleSound(thisPlayer);
    }), false);
    oscEl.appendChild(onoffBtn);

    removeBtn.classList.add("general-btn");

    removeBtn.innerHTML = "X";
    removeBtn.addEventListener("click", (function (event) {
        event.preventDefault();
        destroyAnOscillator(oscEl, thisPlayer);
    }), false);
    oscEl.appendChild(removeBtn);


    // Add mute button
    muteBtn.classList.add("toggle-btn", "mute-btn", "mute" + newId);
    muteBtn.setAttribute('data-muted', 'false');
    muteBtn.appendChild(document.createElement('span'));
    muteBtn.innerHTML = "MUTE";

    muteBtn.addEventListener("click", (function (event) {
        event.preventDefault();

        if (muteBtn.getAttribute('data-muted') === 'false') {
            thisPlayer.gainobj.disconnect(thisPlayer.context.destination);
            muteBtn.setAttribute('data-muted', 'true');
            muteBtn.innerHTML = "UNMUTE";
        } else {
            thisPlayer.gainobj.connect(thisPlayer.context.destination);
            muteBtn.setAttribute('data-muted', 'false');
            muteBtn.innerHTML = "MUTE";
        };

    }), false);
    oscEl.appendChild(muteBtn);




    volumeSlider.setAttribute('type', 'range');
    volumeSlider.setAttribute('min', 0);
    volumeSlider.setAttribute('max', 100);
    volumeSlider.setAttribute('step', 1);
    volumeSlider.setAttribute('value', 50);
    volumeSlider.classList.add("volume-slider", "tone-slider", "vs" + newId);
    volumeSlider.addEventListener("input", (function (event) {
        event.preventDefault();
        setVol(volumeSlider.value, thisPlayer, volumeSlider, volumeBox);
    }), false);

    volumeTxt.innerHTML = "AMPLITUDE (V)";
    volumeTxt.classList.add("bold");
    volumeBoxWrapper.appendChild(volumeTxt);
    volumeBoxWrapper.classList.add("volumeBoxWrapper", "volumeBoxWrapper" + newId);

    volumeBox.setAttribute('type', 'text');
    volumeBox.setAttribute('value', 0.5);
    volumeBox.addEventListener("input", (function (event) {
        event.preventDefault();
        let value = volumeBox.value.trim();
        if (!value || value === "" || value === null) {
            value = 0;
            volumeBox.value = 0;
        }
        const newVol = gain2dBFS(value);
        thisPlayer.gainobj.gain.value = dBFS2gain(parseInt(newVol));
        volumeSlider.value = parseInt(newVol);

        if (thisPlayer.playing === true) {
            ui.gain.value = dBFS2gain(parseInt(newVol));
            update();
        }

    }), false);

    volumeBoxWrapper.appendChild(volumeBox);
    sliderWrapper.appendChild(volumeBoxWrapper);
    sliderWrapper.appendChild(volumeSlider);
    sliderWrapper.classList.add('sliderWrapper');

    oscEl.appendChild(sliderWrapper);
    oscEl.appendChild(dividerDiv);

    freqTxt.innerHTML = "FREQUENCY (Hz)";
    freqTxt.classList.add("bold");
    freqboxwrapper.classList.add("freqBoxWrapper", "freqboxwrapper" + newId);
    freqboxwrapper.appendChild(freqTxt);
    freqBox.setAttribute('type', 'text');
    freqBox.setAttribute('value', 100);
    freqBox.addEventListener("input", (function (event) {
        event.preventDefault();
        if (freqBox.value.length === 0) {
            freqBox.value = 0;
        }
        setFreq(parseInt(freqBox.value), thisPlayer, freqSlider, freqBox);
    }), false);
    freqboxwrapper.appendChild(freqBox);


    sliderWrapper.appendChild(freqboxwrapper);


    freqSlider.setAttribute('type', 'range');
    freqSlider.setAttribute('min', 1);
    freqSlider.setAttribute('max', currFreq);
    freqSlider.setAttribute('value', 100);
    freqSlider.classList.add("freq-slider", "tone-slider", "fs" + newId);
    freqSlider.addEventListener("input", (function (event) {
        event.preventDefault();
        setFreq(parseInt(freqSlider.value), thisPlayer, freqSlider, freqBox);
    }), false);


    sliderWrapper.appendChild(freqSlider);
    oscParentEl.appendChild(oscEl);
    newId++;
}




function toggleSound(player) {
    /** onclick function of the onoff button
     * If oscillator is playing, suspends audiocontext
     * Else, resume audio context
     * Update ui to change onoff button text
     * Written by Rich Nguyen, comment by Alex Li
     * @since 2019.12.20
     * @param {oscillator} player Oscillator that is being toggled on/off
     */
    if (player.playing) {
        player.context.suspend();
        player.playing = false;

        update();

    } else if (player.first === true) {
        player.oscillator.start(0);
        player.first = false;
        player.playing = true;
        update();
    } else {
        player.context.resume();
        player.playing = true;
        update();

    }
}








function setFreq(newFreq, player, sliderfreqEl, boxfreqEl) {
    /** Sets the frequency of an oscillator and redraws the graph if it is playing
     * Written by Rich Nguyen, comment by Alex Li
     * @since 2019.12.17
     * @param {Number} newFreq frequency to set oscillator to
     * @param {Oscillator} player oscillator object who's frequency you are incrementing
     * @param {Element} sliderfreqEl frequency slider of oscillator
     * @param {Element} boxfreqEl input box for frequency of oscillator
     * @return {void} none
     */
    player.oscillator.frequency.value = Math.max(newFreq, 0);
    sliderfreqEl.value = newFreq;
    boxfreqEl.value = newFreq;
    // change only if the play is on
    if (player.playing === true) {
        update();
    }

}



function setVol(newVol, player, volumeSlider, volumeBox) {
    /** Sets amplitude of an oscillator
     * Called by input event listener of volumeSlider of oscillator
     * Written by Rich Nguyen, comment by Alex Li
     * @since 2019.12.20
     * @return {void} none
     * @param {int} newVol Integer value of the amplitude to set oscillator to
     * @param {oscillator} player Oscillator that you are changing the volume of
     * @param {slider} slider Slider element of the oscillator
     * @param {input} volumeBox Input element
     */
    player.gainobj.gain.value = dBFS2gain(parseInt(newVol));
    volumeSlider.value = parseInt(newVol);
    volumeBox.value = dBFS2gain(parseInt(newVol));
    if (player.playing === true) {
        ui.gain.value = dBFS2gain(parseInt(newVol));
        update();
    }
}


function dBFS2gain(dbfs) {
    return (dbfs / 100).toFixed(2);
}


function gain2dBFS(gain) {
    return (gain * 100);
}


function destroyAnOscillator(El, player) {
    /** Removes oscillator from screen.
     * Iterates through oscillators children and removes them, then removes oscillator from parent div and updates ui
     * Called by remove button
     * Written by Rich Nguyen, comment by Alex Li
     * @since 2019.12.21
     * @param {Oscillator} El Oscillator element that we are destroying
     * @param {Object} player Object with AudioContext data
     * @return {void} none
     *
     */
    var kids = El.childNodes, parent = El.parentElement;
    player.context.close();
    for (var i = 0; i < kids.length; i++) {
        El.removeChild(kids[i]);
    }
    parent.removeChild(El);
    update();
}


function createGrid(ctx) {
    /** Generates the grid lines to display the wave curve
     * Draws on the ctx canvas
     * Called by refreshCanvas() and on startup
     * Written by Rich Nguyen, comment by Alex Li
     * @since 2019.12.21
     * @param {canvas} ctx Canvas the grid lines are being drawn on
     * @return {void} none
     */
    ctx.beginPath();
    ctx.moveTo(0, midPoint.y);
    ctx.lineTo(c.width, midPoint.y);
    ctx.moveTo(midPoint.x, 0);
    ctx.lineTo(midPoint.x, c.height);
    ctx.strokeStyle = 'rgba(0, 0, 0, 1.0)';
    ctx.lineWidth = '0.7';
    ctx.globalCompositeOperation = 'source-over';
    ctx.stroke();
    ctx.closePath();


    ctx.beginPath();
    var gridLineX = midPoint.x - 100;
    while (gridLineX >= 0) {
        ctx.moveTo(gridLineX, 0);
        ctx.lineTo(gridLineX, c.height);
        gridLineX -= 100;

    }

    gridLineX = midPoint.x + 100;
    while (gridLineX <= c.width) {
        ctx.moveTo(gridLineX, 0);
        ctx.lineTo(gridLineX, c.height);
        ctx.fillText(gridLineX / 100 * ui.dropdownExample.value, gridLineX, c.height - 3);
        gridLineX += 100;
    }
    var gridLineY = midPoint.y - 100;
    var unitY = 1;
    while (gridLineY >= 0) {
        ctx.moveTo(0, gridLineY);
        ctx.lineTo(c.width, gridLineY);
        ctx.fillText(unitY, 10, gridLineY);
        gridLineY -= 100;
        unitY += 5;
    }

    ctx.fillText(" 0", 10, midPoint.y);
    gridLineY = midPoint.y + 100;
    unitY = -1;
    while (gridLineY <= c.height) {
        ctx.moveTo(0, gridLineY);
        ctx.lineTo(c.width, gridLineY);
        ctx.fillText(unitY, 10, gridLineY);
        gridLineY += 100;
        unitY -= 5;
    }

    // Fill in the dashlines
    var dashesX = midPoint.x - 20;
    while (dashesX >= 0) {
        ctx.moveTo(dashesX, midPoint.y - 5);
        ctx.lineTo(dashesX, midPoint.y + 5);
        dashesX -= 20;
    }
    while (dashesX <= c.width) {
        ctx.moveTo(dashesX, midPoint.y - 5);
        ctx.lineTo(dashesX, midPoint.y + 5);
        dashesX += 20;
    }
    var dashesY = midPoint.y - 20;
    while (dashesY >= 0) {
        ctx.moveTo(midPoint.x - 5, dashesY);
        ctx.lineTo(midPoint.x + 5, dashesY);
        dashesY -= 20;
    }
    dashesY = midPoint.y + 20;
    while (dashesY <= c.height) {
        ctx.moveTo(midPoint.x - 5, dashesY);
        ctx.lineTo(midPoint.x + 5, dashesY);
        dashesY += 20;
    }

    ctx.stroke();

}

/**
 * animate is used to update the graph when streaming is on (i.e. the microphone is being used)
 * Written by Rich Nguyen
 * Comment by Eric Stein
 * @since 2/12/20
 */
function animate() {

    if (streaming === true && ui.freeze.value === false) {
        analyser.getByteTimeDomainData(timeDomain);
        window.requestAnimationFrame(animate);
    }

    drawData();
}

const clearScope = () => {
    ctx2.clearRect(0, 0, c.width, c.height);
}

/**
 * drawData is used to update the graph with all relevant waves
 * Written by Rich Nguyen, Modified by Eric Stein
 * Comment by Eric Stein
 * @since 2/12/20
 */
function drawData() {
    const selectedAudioInput = audioInputSourceSelect.options[audioInputSourceSelect.selectedIndex];
    if (selectedAudioInput === undefined) return;
    let selectedAudioInputValue = selectedAudioInput.value;
    if (selectedAudioInputValue === "Oscillators") {
        streaming = false
    }

    dots = [];
    ctx2.translate(-previousTranslate.x, -previousTranslate.y);
    clearScope();

    ctx2.translate(0, ui.vertOffset.value);
    ctx2.beginPath();


    // Get all needed on, gain, and freq.


    var gainArr = [];
    var freqArr = [];
    var idx = 0;
    // create osc data
    var oscs = document.getElementsByClassName('oscillator');
    // Check to see how many element.
    var numOsc = oscs.length;
    for (var i = 0; i < numOsc; i++) {
        // Check if the button is on
        if (oscs[i].getElementsByClassName("toggle-btn switch").length > 0) {
            //Get the Amplitude Gain
            var volumeSlider = oscs[i].getElementsByClassName("volume-slider")[0].value;
            gainArr[idx] = dBFS2gain(parseInt(volumeSlider));
            var freqSlider = oscs[i].getElementsByClassName("freq-slider")[0].value;
            freqArr[idx] = Math.max(freqSlider, 0);
            idx++;
        }
    }
    // create Snap! data
    if (currentSnapiFrame !== null) {
        var snapSounds = currentSnapiFrame.getSounds()
        for (i = 0; i < snapSounds.length; i++) {
            let snapSoundData = snapSounds[i];
            if (snapSoundData !== null) {
                gainArr[idx] = snapSoundData.gain
                freqArr[idx] = snapSoundData.freq
                idx++
            }
        }
    }

    var itemWeight = 1;

    for (i = 0; i <= analyser.frequencyBinCount; i++) {
        var index = i;
        var yTip = 0;
        var xc = 0;
        var yc = 0;
        if (streaming === true) {
            xc = i * (c.width / analyser.frequencyBinCount);
            yc = ui.gain.value * ((timeDomain[index] / 255) - 0.5) * 200 / (ui.volts.value);
            yTip = yc;
            yc += c.height / 2;

            xc = mapRange([0, 0.001 * ui.dropdownExample.value], [0, 100 * (numSamples / sampleRate) / c.width], xc);

            ctx2.lineTo(xc, yc);

        } else {
            xc = i * (c.width / analyser.frequencyBinCount);

            // 100 pixels per division
            var amplitude = 100 / ui.volts.value;

            //so total length in seconds of graph is sampleRate*numSamples
            //=0.0053333seconds, so 1 pixel represents 0.00533/width seconds
            //by default 100px represents 100*0.00533/width  = ??? seconds
            //we want it to represent 1ms
            yc = 0;
            for (idx = 0; idx < gainArr.length; idx++) {
                if (gainArr[idx] !== null) {
                    var ycItem = -amplitude * Math.sin(2 * Math.PI * xc * freqArr[idx] * 0.00001 * ui.dropdownExample.value); //0.00001 is the number of seconds we want a pixel to represent, ie 1ms / 100
                    //apply gain
                    ycItem *= gainArr[idx];
                    // Combine signal;
                    yc += ycItem * itemWeight;
                }
            }

            //center vertically
            yTip = yc;
            yc = c.height / 2 + yc;

            ctx2.lineTo(xc, yc);
        }
        dots.push({
            x: xc,
            y: yc,
            yTip: yTip
        });
    }

    previousTranslate = { x: 0, y: ui.vertOffset.value };
    // Use multiple stroke for smoothing effect
    ctx2.strokeStyle = 'rgba(0, 0, 0, 0.5)';
    ctx2.lineWidth = 1;
    ctx2.stroke();

    ctx2.strokeStyle = 'rgba(0, 0, 0,0.5)';
    ctx2.lineWidth = 3;
    ctx2.stroke();
    ctx2.strokeStyle = 'rgba(0, 0, 0, 0.3)';
    ctx2.lineWidth = 4;
    ctx2.stroke();

}

function y2amplitude(y) {
    return -(y / 100).toFixed(2);
}

function x2time(x) {
    return (x / 100 * ui.dropdownExample.value).toFixed(1);
}


function handleError(error) {
    console.log('navigator.MediaDevices.getUserMedia error: ', error.message, error.name);
}






var elmRoot = document.getElementById("root");
var logoBtn = document.getElementById("tunescope");
var target = document.getElementById("header");
var slt = document.getElementById("selectDiv");
slt.style.opacity = 1;
var currColor = target.style.backgroundColor;
var elmMain = document.getElementById("mainBody");







var collapseButton = document.createElement('button');
collapseButton.classList.add("btn", "btn-light", "mx-1");
collapseButton.id = 'collapseMenu';
collapseButton.innerHTML = "<";
slt.appendChild(collapseButton);
var currTheme = 'light';




let createExpandButton = () => {
    let expdBtn = document.createElement('button');
    expdBtn.classList.add("btn", "bg-light", "mt-3", "ml-1");
    expdBtn.appendChild(document.createElement('span'));
    expdBtn.innerHTML = ">";
    expdBtn.addEventListener("click", (function () {
        expdBtn.remove();
        menuCollapsed = false;
        if (currentSnapiFrame != null) {
            if (currentSnapiFrame.expanded) {
                setTimeout(function () {
                    currentSnapiFrame.expand();
                }, 100);
            }
        }

        elmMain.style.height = '90%';
        elmMain.style.top = '10%';
        target.style.width = '100%';
        target.style.height = '10%';
        target.style.backgroundColor = currColor;
        target.style.boxShadow = '0px 1px 10px #999';
        setTimeout(function () {
            slt.style.opacity = '1';
            slt.style.right = '5%';
            slt.style.display = '';
        }, 200);
        if (currTheme === 'light') {
            logoBtn.style.content = 'url(TuneScope.png)';
        } else if (currTheme === 'dark') {
            logoBtn.style.content = 'url(darkTuneScope.png)';
        }
        logoBtn.style.width = '18vw';
        logoBtn.classList.remove("mt-3");
    })
    );
    return expdBtn;
}






function leftCollapse() {

    console.log('collpasing');

    //normal -> collapsed
    if (slt.style.opacity > 0) {
        menuCollapsed = true;
        slt.style.opacity = '0';
        slt.style.right = '30%';
        setTimeout(function () {
            slt.style.display = 'none';

        }, 1000);
        target.style.width = '18%';
        target.style.height = '5%';

        target.style.backgroundColor = '#ffffff00';
        target.style.boxShadow = 'none';
        console.log(logoBtn.style.content);
        if (currTheme === 'light') {
            logoBtn.style.content = 'url(LtMin.png)';
        } else if (currTheme === 'dark') {
            logoBtn.style.content = 'url(DkMin.png)';
        }
        logoBtn.style.width = '8.8vw';
        logoBtn.classList.add("mt-3");
        setTimeout(function () {
            elmMain.style.height = '95%';
            elmMain.style.top = '5%';
        }, 200);
        if (currentSnapiFrame != null) {
            if (currentSnapiFrame.expanded) {
                setTimeout(function () {
                    currentSnapiFrame.expand();
                }, 100);
            }
        }

        var expdButton = createExpandButton();
        document.getElementById('preamble').appendChild(expdButton);

    }
    else
    //collapsed to normal
    {
        menuCollapsed = false;
        if (currentSnapiFrame != null) {
            if (currentSnapiFrame.expanded) {
                setTimeout(function () {
                    currentSnapiFrame.expand();
                }, 100);
            }
        }


        elmMain.style.height = '90%';
        elmMain.style.top = '10%';
        target.style.width = '100%';
        target.style.height = '10%';
        target.style.backgroundColor = currColor;
        target.style.boxShadow = '0px 1px 10px #999';
        setTimeout(function () {
            slt.style.opacity = '1';
            slt.style.right = '5%';
            slt.style.display = '';
        }, 200);
        if (currTheme === 'light') {
            logoBtn.style.content = 'url(TuneScope.png)';
        } else if (currTheme === 'dark') {
            logoBtn.style.content = 'url(darkTuneScope.png)';
        }
        logoBtn.style.width = '18vw';
        logoBtn.classList.remove("mt-3");
    }
}



leftCollapse();


document.addEventListener('DOMContentLoaded', function () {

    collapseButton.addEventListener('click', function () { leftCollapse(); });
    var checkbox = document.querySelector('input[type="checkbox"]');

    checkbox.addEventListener('change', function () {


        var elmMain = document.querySelectorAll("[id='mainBody']");
        var elmHeader = document.querySelectorAll("[id='header']");


        if (checkbox.checked) {
            logoBtn.style.content = 'url(darkTuneScope.png)';
            console.log('Changed to Dark Mode');
            currTheme = 'dark';
            elmRoot.style.backgroundColor = '#313131';
            for (var i = 0; i < elmMain.length; i++)
                elmMain[i].style.backgroundColor = '#313131';
            document.body.style.color = '#ffffff';
            for (i = 0; i < elmHeader.length; i++) {
                elmHeader[i].style.backgroundColor = '#525252';
                elmHeader[i].style.boxShadow = '0px 1px 10px #999';
            }
            setTimeout(function () { currentSnapiFrame.setDarkTheme(); }, 500);


        } else {

            logoBtn.style.content = 'url(TuneScope.png)';
            console.log('Changed to Light Mode');
            currTheme = 'light';
            elmRoot.style.backgroundColor = '#ffffff';
            for (i = 0; i < elmMain.length; i++) {
                elmMain[i].style.backgroundColor = '#ffffff';
            }
            document.body.style.color = '#232d4b';
            for (i = 0; i < elmHeader.length; i++) {
                elmHeader[i].style.backgroundColor = '#f0f0f5';
                elmHeader[i].style.boxShadow = '0px 1px 10px #999';
            }
            setTimeout(function () { currentSnapiFrame.setFlatTheme(); }, 500);


        }
        currColor = target.style.backgroundColor;
    });


});
